import {getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {EventText} from '../../../../../commons/components/event-text'
import {useEventDateInformation} from '../../../../../commons/hooks/dates'
import {useMobileFontOverrides} from '../../../../../commons/hooks/use-mobile-font-overrides'
import {getEventOrders, hasOrder} from '../../selectors/event'
import {OrderDetails} from '../order-details'
import s from './event-details.scss'
import {EventDetailsProps} from '.'

export const EventDetails = ({event, mobile, primaryButton, secondaryButton, shareButton}: EventDetailsProps) => {
  const {startDate} = useEventDateInformation(event.event.id)
  const {mobileFontOverridesEnabled} = useMobileFontOverrides()

  return (
    <>
      <div className={classNames(s.details, {[s.mobile]: mobile})}>
        <div>
          <EventText faded extraClass={mobileFontOverridesEnabled ? s.infoText : null} dataHook={DH.START_DATE}>
            {startDate}
          </EventText>
        </div>
        <div className={s.location}>
          <EventText faded extraClass={mobileFontOverridesEnabled ? s.infoText : null} dataHook={DH.FULL_LOCATION}>
            {getFormattedFullLocation(event.event)}
          </EventText>
        </div>
        <div className={s.actions}>
          <div className={s.leftActions}>
            {primaryButton}
            <div className={s.actionButton}>{secondaryButton}</div>
          </div>
          {shareButton}
        </div>
      </div>
      {hasOrder(event) && !mobile
        ? getEventOrders(event).map(order => <OrderDetails key={order.orderNumber} order={order} event={event} />)
        : null}
    </>
  )
}
